import './vendor/jquery.matchHeight';

jQuery(function ($) {

	'use strict';

	// STICKY HEADER

	$('header').affix({
		offset: {
			top: 1,
		}
	});

	// ACTIVATE MOBILE NAVIGATION

	$('.mobile-nav-toggle').on('click', function (event) {
		event.preventDefault();
		$('body').toggleClass('offcanvas-expanded');
	});

	// CUSTOM SELECTS

	$('.filter__select').select2({
		minimumResultsForSearch: Infinity,
	});

	// VIDEO POPUP

	$('.video-popup').magnificPopup({
		disableOn: 767,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});

	// BODY CLASS
	$('body').addClass('doc-ready');

	// GOTO LINK SCROLLING

	$(function () {
		$('.scroll-to').on('click', function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top
					}, 1000);
					return false;
				}
			}
		});
	});

	// INFINITE SCROLL

	var dataLoader = null;
	var elementWatcher = null;

	function handleEnterViewport(self) {
		var element = $(self.watchItem);
		var anchor = $('a', element);
		var selector = element.data('container');
		var container = $('#items');
		if (anchor.length > 0) {
			$.ajax({
				url: anchor.attr('href'),
				type: 'GET',
				dataType: 'html',
				dataFilter: function (response) {
					dataLoader.html($(response).find('div.data-loader').html());
					return $(response).find('div#items');
				},
				success: function (response) {
					container.append($($(response).html().trim()).hide().fadeIn(300));
					infiniteScrollWatcher();
				}
			});
		} else {
			self.destroy();
			anchor.remove();
		}
	}

	function infiniteScrollWatcher() {
		if (elementWatcher != null)
			elementWatcher.destroy();
		dataLoader = $('.data-loader');
		elementWatcher = scrollMonitor.create(dataLoader);
		elementWatcher.enterViewport(function () {
			handleEnterViewport(this);
		});
	}

	// NEWS EQUAL HEIGHT

	function equalHeight() {
		var highestBox = 0;

		$('.news-item').each(function(){  
		
			if($(this).height() > highestBox) {
				highestBox = $(this).height(); 
			}
						
		}); 

		$('.news-item').height(highestBox);
	}

	equalHeight();


	// NEWS FILTER

	if ($('form#news-filter-form').length > 0) {
		$('form#news-filter-form')
			.on('submit', function (event) {
				event.preventDefault();
				var form = $(this);
				$('#items').fadeTo(300, 0.5);
				$.ajax({
					url: form.attr('action'),
					type: form.attr('method'),
					dataType: 'html',
					data: form.serialize(),
					success: function (response) {
						var data = $(response).find('#items').html();
						if (data.trim() != '') {
							$('#items').html(data).fadeTo(300, 1);
							dataLoader.html($(response).find('div.data-loader').html());
						} else {
							$('#items').html('<h3>No results.</h3>');
						}
						//infiniteScrollWatcher();
						equalHeight();
					}
				});
			})
			.on('change', function (event) {
				event.preventDefault();
				$(this).trigger('submit');
			})
			;
		//infiniteScrollWatcher();
		equalHeight();
	}

	$('.js-load-news').on('click', function() {
		let dataLoader = $('.data-loader');
		let container = $('#items');
		let anchor = $('.data-loader a');
		let notify = $('.js-load-news');
		
		notify.text('Loading ...');

		$.ajax({
			url: anchor.attr('href'),
			type: 'GET',
			dataType: 'html',
			dataFilter: function (response) {
				dataLoader.html($(response).find('div.data-loader').html());
				return $(response).find('div#items');
			},
			success: function (response) {
				container.append($($(response).html().trim()).hide().fadeIn(300));
				$('.data-loader').hide();
				notify.text('Load More');
				equalHeight();
			}
		});
	});

	var intv;
	var current = 2;
	var slt = $('.js-slide-switch a').length;

	function auto(){
		intv = setInterval(function() {
			$('.js-slide-switch a:nth-child(' + current + ')').trigger('click');
			if ( current <= slt ) {
				current++;
			} else {
				current = 1;
			}
		}, 4000 );       
	}
	
	auto();

	$('.news-slide').on('mouseenter mouseleave', function( e ){
		var onMouEnt = e.type=='mouseenter' ? clearInterval(intv) : auto() ;
	});

	// HOMEPAGE CASE STUDIES

	var slideshowHasHoverState = false;

	function adjustStudyImageWidth() {
		var count = $('.slider-images__item').length;
		var width = Math.floor(40 / (count - 1));
		$('.slider-images__item').css({
			width: Math.floor(40 / (count - 1)) + "%"
		});
	}

	function updateStudyImage(prev_index, current_index) {
		$($('.slider-images__item')[prev_index]).removeClass('active');
		$($('.slider-images__item')[current_index]).addClass('active');
	}

	function updateStudyContent(index) {
		var study = $($('.slider-images__item')[index]);
		$('p[data-key="intro"]').text(study.data('intro'));
		$('p[data-key="quote"]').text(study.data('quote'));
		$('span[data-key="cite"]').text(study.data('cite'));
		if (study.data('logo') != '') {
			$('div[data-key="logo"]').html(
				$('<img/>').attr('src', study.data('logo'))
			);
		} else {
			$('div[data-key="logo"]').html('');
		}
	}

	function initStudySlideshow() {
		var slideshow_length = $('.slider-images__item').length;
		setInterval(function () {
			if (!slideshowHasHoverState) {
				var current_item = $('.slider-images__item.active');
				var current_item_index = current_item.index();
				var next_item_index = current_item_index + 1;
				if (next_item_index > slideshow_length - 1) {
					next_item_index = 0;
				}
				updateStudyImage(current_item_index, next_item_index);
				updateStudyContent(next_item_index);
			}
		}, 6000);
	}

	if ($('body').hasClass('homepage')) {
		// Adjust default image width
		adjustStudyImageWidth();
		// Initialize slideshow
		initStudySlideshow();
		// Handle image hover event
		$('.slider-images__item')
			.on('mouseover', function () {
				slideshowHasHoverState = true;
				var current_item = $(this);
				var prev_item = $('.slider-images__item.active');
				if (current_item.index() != prev_item.index()) {
					updateStudyImage(prev_item.index(), current_item.index());
					updateStudyContent(current_item.index());
				}
			})
			.on('mouseout', function () {
				slideshowHasHoverState = false;
			})
			;
		// Handle arrow click event
		$('.slider-arrows__arrow').on('click', function (event) {
			event.preventDefault();
			var prev_item = $('.slider-images__item.active');
			if ($(this).hasClass('slider-arrows__arrow--right')) {
				if (prev_item.index() != ($('.slider-images__item').length - 1)) {
					updateStudyImage(prev_item.index(), prev_item.index() + 1);
					updateStudyContent(prev_item.index() + 1);
				} else {
					updateStudyImage(prev_item.index(), 0);
					updateStudyContent(0);
				}
			} else {
				if (prev_item.index() != 0) {
					updateStudyImage(prev_item.index(), prev_item.index() - 1);
					updateStudyContent(prev_item.index() - 1);
				} else {
					updateStudyImage(prev_item.index(), $('.slider-images__item').length - 1);
					updateStudyContent($('.slider-images__item').length - 1);
				}
			}
		});
	}

	/* HOVER BLOCK DESCRIPTION HEIGHT PATCH

	var viewportWidth = $(window).width();

	$(window).on('resize', function() {
		viewportWidth = $(window).width();
		if ( viewportWidth < 768 ) {
			$('.service-block__description').each(function(index, item){
				var cssObject = $(item).prop('style');
				cssObject.removeProperty('height');
			});
		}
	});

	$('.service-block')
		.on('mouseover', function(){
			if (viewportWidth >= 768) {
				$('.service-block__description', this).css({
					height: $('.service-block__description > p').height()
				});
			}
		})
		.on('mouseout', function(){
			if (viewportWidth >= 768) {
				$('.service-block__description', this).css({
					height: 0
				});
			}
		})
	;*/

	// SERVICES ACCORDION

	/*
	$('.service-block__description').hide();
	$('.service-block__header').on('click', function(){
		if ($(this).hasClass('selected')) {
			$(this).removeClass('selected');
			$(this).next().slideUp();
		} else {
			$('.service-block__header').removeClass('selected');
			$(this).addClass('selected');
			$('.service-block__description').slideUp();
			$(this).next().slideDown();
		}
		return false;
	});
	*/

	// ACCORDION

	$('.accordion-block__content').hide();
	$('.accordion-block__header').on('click', function () {
		if ($(this).hasClass('selected')) {
			$(this).removeClass('selected');
			$(this).next().slideUp();
		} else {
			$('.accordion-block__header').removeClass('selected');
			$(this).addClass('selected');
			$('.accordion-block__content').slideUp();
			$(this).next().slideDown();
		}
		return false;
	});

	// TEAM SLIDER

	function adjustOurTeamSpacers() {
		if ($(window).width() > 1194) {
			$('.our-team .spacer').css({ width: ($(window).width() - 1194) / 2 });
		} else {
			$('.our-team .spacer').css({ width: 0 });
		}
	}

	if ($('.our-team').length > 0) {
		adjustOurTeamSpacers();
		$(window).on('resize', function () {
			adjustOurTeamSpacers();
		});
	}

	$(".our-team").mCustomScrollbar({
		axis: "x",
		theme: "dark-thin",
		autoExpandScrollbar: false,
		autoDraggerLength: false,
		advanced: { autoExpandHorizontalScroll: true }
	});

	// HOMEPAGE LOGO SLIDER

	function adjustLogoSpacers() {
		if ($(window).width() > 1194) {
			$('.logo-slider .spacer').css({ width: ($(window).width() - 1194) / 2 });
		} else {
			$('.logo-slider .spacer').css({ width: 0 });
		}
	}

	if ($('.logo-slider').length > 0) {
		adjustLogoSpacers();
		$(window).on('resize', function () {
			adjustLogoSpacers();
		});
	}

	$(".logo-section").mCustomScrollbar({
		axis: "x",
		theme: "dark-thin",
		autoExpandScrollbar: false,
		autoDraggerLength: false,
		advanced: { autoExpandHorizontalScroll: true }
	});

	// CONTACT VIDEO

	$('#bg-video').on('DOMNodeInserted', function (event) {
		if ($(event.target).is('video')) {
			$(event.target).on('ended', function () {
				$('.subheader-banner.subheader-banner--video').addClass('video-finished');
			});
		}
	});

	// MATCH HEIGHT

	$('.team-member').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});

	// News slider


	$('.js-slide-switch a').on('click', function(e) {
		e.preventDefault();
		var target = $(this).attr('href');
		$(this).siblings().removeClass('is-active');
		$(this).toggleClass('is-active');
		$(target).siblings().removeClass('is-active');
		$(target).addClass('is-active');
	});

}(jQuery));
